import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { AddCardPage } from '@/billing/pages/add-card';

export const Route = createFileRoute('/billing/payment-methods/new-card')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: NewCardRoute,
  staticData: {
    headerSection: 'billing'
  }
});

function NewCardRoute() {
  return <AddCardPage/>;
}
